import { cleanObj, HelpParseKeyValueString2 } from "helpers/HelpParseKeyValueString";
import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import GWPagosAvatarCss from "components/GWAvatar/GWPagosAvatar.css";

const resultListConfigs = [
  {
    result: 'DONE',
    color: "#28a745",
  },
  {
    result: 'PENDING',
    color: "#ffc107",
  },
  {
    result: 'FAILED',
    color: "#dc3545",
  },
  {
    result: 'ABORTED',
    color: "#dc3545",
  },
]

const GWPagosAvatarAliados = () => {
  const estiloCentrado = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh", // O ajusta la altura según tus necesidades
  };
  const location = useLocation();

  const [callbackUrl, setCallbackUrl] = useState(urlOptions[0]?.value);

  const handleButtonClick = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  const handleButtonClickPost = (url) => {
  if (url) {
    redirectPost(url);
  }
};

function redirectPost(url) {
  const urlParsed = new URL(url);

  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;

  urlParsed.searchParams.forEach((value, key) => {
    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = key;
    hiddenField.value = value;
    form.appendChild(hiddenField);
  });

  document.body.appendChild(form);
  form.submit();
}

  const allParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    if (!searchParams) return {}

    const params = HelpParseKeyValueString2(
      location.search
    );

    return cleanObj(params)
  }, [location])

  const resultLinks = useMemo(() => {
    return resultListConfigs?.map((obj) => {
      const { tran_id } = HelpParseKeyValueString2(
        location.search
      );
      const generatedUrl = `${callbackUrl}?result=${obj.result}&tran_id=${tran_id}`;
      return {
        ...obj,
        url: generatedUrl,
      }
    })
  }, [location, callbackUrl])

  return (
    <div className="container" style={estiloCentrado}>
      <div className="Contenido-GWavatar">
        <h2>GW Pagos Avatar Aliados</h2>
        <div className="Contenido-Body-Aliados">
          <ol className="lista-body">
            {Object.entries(allParams).length > 0 ? (
              Object.entries(allParams).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong> {value}
                </li>
              ))
            ) : (
              <li>No se encontró parametros</li>
            )}
          </ol>
        </div>

        <div >
          {urlOptions.map(({ name, value }) => (
            <div key={value} style={{ width: 'fit-content' }}>
              <Form.Check
                type={"radio"}
                id={name}
                value={value}
                label={<p>{name} <span className="small text-muted">({value})</span></p>}
                checked={callbackUrl === value}
                onChange={(e) => setCallbackUrl(e.target.value)}
              />
            </div>
          ))}
        </div>
        <div className="contenido-botones">
          {
            resultLinks?.map((obj) => (<button
            key={obj.result}
            className="dimension-botones"
            onClick={() => handleButtonClick(obj.url)}
            style={{ backgroundColor: obj.color}}
          >
            {obj.result}
          </button>))
          }
        </div>
        <div className="contenido-botones">
          {resultLinks?.map((obj) => (
            <button
              key={`${obj.result}-post`}
              className="dimension-botones"
              onClick={() => handleButtonClickPost(obj.url)}
              style={{ backgroundColor: obj.color }}
            >
              POST {obj.result}
            </button>
          ))}
</div>
      </div>
    </div>
  );
};
export default GWPagosAvatarAliados;

const urlOptions = [
  {
    name: 'QA',
    value: 'https://www.claroco2-auth.avatar-global.com/aliados/retorno-de-pasarela',
  },
  {
    name: 'Dev',
    value: 'https://localhost:3343/aliados/retorno-de-pasarela',
  },
]
